import { render, staticRenderFns } from "./buyindex.vue?vue&type=template&id=7b83c1c8&scoped=true&"
import script from "./buyindex.vue?vue&type=script&lang=js&"
export * from "./buyindex.vue?vue&type=script&lang=js&"
import style0 from "./buyindex.vue?vue&type=style&index=0&id=7b83c1c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b83c1c8",
  null
  
)

export default component.exports